import { createAction } from '@reduxjs/toolkit';

import { packRosterModuleNamespace } from '../../common';

/**
 * Roster fetch was intentionally not performed (e.g. lite-roster users who must
 * never load the full roster). This also ensures cleanup of the `loading` flags.
 */
export const packRosterSkipped = createAction(
  `${packRosterModuleNamespace}/PACK_ROSTER_SKIPPED`,
);
